export default class ProductsService {

    constructor(resource) {
        this._resource = resource('block/produtos');
    }

    blocks() {
        return this._resource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de publicacoes.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/ProductsService.js